import { render } from "./TrafficChart.vue?vue&type=template&id=2378dfc0&scoped=true"
import script from "./TrafficChart.vue?vue&type=script&lang=js"
export * from "./TrafficChart.vue?vue&type=script&lang=js"

import "./TrafficChart.vue?vue&type=style&index=0&id=2378dfc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2378dfc0"]])

export default __exports__